import React from 'react';
import { Link } from 'react-router-dom';
import s from './Privacy.module.css';

const OWNER = 'לירית לנגר';
const STUDIO = 'סטודיו לנגר - אדריכלות ועיצוב פנים';
const EMAIL = 'lirit@langerarch.com';
const PHONE = '052-485-3300';
const ADDRESS = 'הכרמים 6, אלוני אבא, עמק יזרעאל';
const DOMAIN = 'langerarch.com';
const UPDATE_DATE = 'אפריל 2026';

export default function Privacy() {
  return (
    <main className={s.page}>
      <div className={s.inner}>
        <header className={s.header}>
          <Link to="/new" className={s.back}>
            <span className={s.backArrow}>→</span>
            <span>חזרה לאתר</span>
          </Link>
          <h1 className={s.title}>
            תקנון, תנאי שימוש ומדיניות פרטיות
          </h1>
          <p className={s.sub}>{STUDIO}</p>
          <div className={s.meta}>
            <span>עודכן לאחרונה: {UPDATE_DATE}</span>
          </div>
        </header>

        <div className={s.card}>
          <section className={s.section}>
            <p className={s.intro}>
              בעל האתר: {OWNER}, {ADDRESS}
              <br />
              דוא״ל: <a href={`mailto:${EMAIL}`} className={s.inlineLink}>{EMAIL}</a>
              <br />
              טלפון: <a href={`tel:+972524853300`} className={s.inlineLink}>{PHONE}</a>
              <br />
              כתובת האתר: {DOMAIN}
            </p>
          </section>

          <section className={s.section}>
            <h2 className={s.h2}>1. מבוא</h2>
            <p className={s.text}>
              ברוכים הבאים לאתר {DOMAIN} ("האתר"). השימוש באתר, בתכניו ובשירותיו כפוף
              לתנאים המפורטים במסמך זה ("התקנון"), ומהווה את הסכמתכם לכל תנאיו.
              אם אינכם מסכימים לאחד או יותר מהתנאים - אנא הימנעו משימוש באתר.
            </p>
            <p className={s.text}>
              האתר משמש כפלטפורמה להצגת שירותי אדריכלות ועיצוב הפנים של {STUDIO},
              לרבות תיק עבודות, שירותים וטפסי יצירת קשר.
            </p>
            <p className={s.text}>
              התקנון נוסח בלשון זכר מטעמי נוחות בלבד אך מיועד לשני המינים.
            </p>
          </section>

          <section className={s.section}>
            <h2 className={s.h2}>2. שימוש מותר באתר</h2>
            <p className={s.text}>
              השימוש באתר מיועד למטרות פרטיות בלבד, ואינו מקנה לכם זכות להעתיק,
              לשכפל, לשנות, להפיץ או לפרסם תכנים מהאתר ללא אישור בכתב ומראש מבעל האתר.
            </p>
            <p className={s.text}>
              חל איסור לעשות שימוש באתר או בשירותיו לכל מטרה בלתי חוקית, לרבות
              פגיעה בפרטיות, חדירה למערכות, הפצת דואר זבל או ניסיון להונות.
            </p>
            <p className={s.text}>
              אין לקשר לאתר מאתרים בעלי תכנים פוגעניים, פורנוגרפיים, מפלים או
              המעודדים פעילות בלתי חוקית.
            </p>
          </section>

          <section className={s.section}>
            <h2 className={s.h2}>3. הרשאה לדיוור ושיווק</h2>
            <p className={s.text}>
              מסירת פרטים באתר מהווה הסכמה לקבלת תוכן שיווקי, עדכונים והצעות
              פרסום בהתאם לחוק התקשורת (בזק ושידורים), תשמ״ב-1982, תיקון 40.
            </p>
            <p className={s.text}>
              ניתן להסיר עצמכם בכל עת מרשימת התפוצה באמצעות פנייה ישירה לבעל האתר
              בכתובת <a href={`mailto:${EMAIL}`} className={s.inlineLink}>{EMAIL}</a>.
            </p>
            <p className={s.text}>
              חל איסור למסור באתר פרטים של אדם אחר ללא הסכמתו המפורשת.
            </p>
          </section>

          <section className={s.section}>
            <h2 className={s.h2}>4. איסוף מידע ושימוש בו (מדיניות פרטיות)</h2>
            <p className={s.text}>
              האתר פועל בהתאם לחוק הגנת הפרטיות, התשמ"א-1981, ותקנות הגנת הפרטיות
              (אבטחת מידע), לרבות תיקון 13 (2024).
            </p>

            <h3 className={s.h3}>4.1 סוגי המידע הנאספים:</h3>
            <ul className={s.list}>
              <li>
                מידע שאתם מוסרים ישירות: שם, פרטי קשר, תוכן פנייה, פרטי הפרויקט
                והשירות שבו התעניינתם.
              </li>
              <li>
                מידע הנאסף אוטומטית: כתובת IP, סוג דפדפן, מערכת הפעלה, מיקומי
                גלישה, נתוני שימוש באתר, Cookies.
              </li>
            </ul>

            <h3 className={s.h3}>4.2 מטרות השימוש במידע:</h3>
            <ul className={s.list}>
              <li>מענה לפניות ואספקת השירותים שביקשתם.</li>
              <li>תיאום פגישות היכרות ומסירת מידע מקצועי רלוונטי.</li>
              <li>התאמת חוויית הגלישה באתר.</li>
              <li>ניתוח סטטיסטי ושיפור האתר והשירותים.</li>
              <li>עמידה בהוראות הדין.</li>
            </ul>

            <h3 className={s.h3}>4.3 זכויותיכם:</h3>
            <ul className={s.list}>
              <li>עיון במידע שנאסף אודותיכם.</li>
              <li>בקשה לתיקון או למחיקה של המידע.</li>
              <li>התנגדות לקבלת דיוור שיווקי.</li>
            </ul>
            <p className={s.text}>
              לפניות בנושא פרטיות: <a href={`mailto:${EMAIL}`} className={s.inlineLink}>{EMAIL}</a>
            </p>
          </section>

          <section className={s.section}>
            <h2 className={s.h2}>5. Cookies וטכנולוגיות מעקב</h2>
            <p className={s.text}>
              האתר משתמש ב-Cookies וכלים אנליטיים לצורך תפעול, שיפור והתאמת
              חוויית המשתמש. ניתן לחסום אותם דרך הגדרות הדפדפן, אך זה עלול לפגוע
              בחוויית השימוש באתר.
            </p>
          </section>

          <section className={s.section}>
            <h2 className={s.h2}>6. אחריות והגבלת אחריות</h2>
            <p className={s.text}>
              התכנים באתר ניתנים כמות שהם (AS IS). אין התחייבות להתאמה מלאה
              לצרכים הספציפיים שלכם, ואין לראות בתכנים המוצגים תחליף לייעוץ
              אישי ומותאם.
            </p>
            <p className={s.text}>
              בעל האתר אינו אחראי לנזק ישיר או עקיף הנובע מהסתמכות על התכנים
              המוצגים באתר.
            </p>
          </section>

          <section className={s.section}>
            <h2 className={s.h2}>7. קניין רוחני</h2>
            <p className={s.text}>
              כל הזכויות בתכנים, בצילומים, בעיצובים, בלוגו ובתיק העבודות המוצג
              באתר שמורות ל{STUDIO}, אלא אם צוין אחרת. אין להעתיק, לשכפל או
              להשתמש בתכנים ללא אישור מפורש בכתב.
            </p>
          </section>

          <section className={s.section}>
            <h2 className={s.h2}>8. אבטחת מידע</h2>
            <p className={s.text}>
              האתר מיישם אמצעי הגנה מתקדמים לפי הוראות החוק. במקרה של פריצה
              או חשש לפריצה, תינתן הודעה לרשות להגנת הפרטיות ולמשתמשים
              הרלוונטיים בהתאם לחוק.
            </p>
          </section>

          <section className={s.section}>
            <h2 className={s.h2}>9. שינויים במדיניות</h2>
            <p className={s.text}>
              בעל האתר רשאי לעדכן את התקנון ומדיניות הפרטיות מעת לעת. שימוש
              באתר לאחר העדכון מהווה הסכמה לתנאים המעודכנים.
            </p>
          </section>

          <section className={s.section}>
            <h2 className={s.h2}>10. יצירת קשר</h2>
            <p className={s.text}>
              לשאלות, פניות או בקשות בנושא התקנון ומדיניות הפרטיות:
            </p>
            <p className={s.text}>
              {OWNER}
              <br />
              {STUDIO}
              <br />
              {ADDRESS}
              <br />
              דוא״ל: <a href={`mailto:${EMAIL}`} className={s.inlineLink}>{EMAIL}</a>
              <br />
              טלפון: <a href="tel:+972524853300" className={s.inlineLink}>{PHONE}</a>
            </p>
          </section>
        </div>

        <Link to="/new" className={s.backBottom}>
          <span className={s.backArrow}>→</span>
          <span>חזרה לאתר הסטודיו</span>
        </Link>
      </div>
    </main>
  );
}
